import React, { useRef } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import { AppBar, Toolbar, Typography, Button, Box, Paper } from "@mui/material";
import { Save, Cancel } from "@mui/icons-material";
import AddEditChallenges from "../../AddEditChallenges/AddEditChallenges";
import MainContentContainer from "../../MainContentContainer/MainContentContainer";

const ChallengeAddEditPage = () => {
  const location = useLocation();
  const { id } = useParams();
  const isEdit = location.pathname.indexOf("edit") > -1;
  const challengeRef = useRef();

  const handleSave = (e) => {
    e.preventDefault();
    challengeRef.current?.submit();
  };

  return (
    <MainContentContainer sx={{ paddingBottom: 4 }}>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {isEdit ? "Edit Challenge" : "Create New Challenge"}
          </Typography>
          <Button
            color="error"
            component={Link}
            to="/challenges"
            startIcon={<Cancel />}
            variant="contained"
            sx={{ marginRight: 2 }}
          >
            Cancel
          </Button>
          <Button
            color="success"
            onClick={handleSave}
            startIcon={<Save />}
            variant="contained"
          >
            {isEdit ? "Update" : "Create"}
          </Button>
        </Toolbar>
      </AppBar>
      <Box gap={4}>
        <Paper sx={{ padding: 2 }}>
          <AddEditChallenges ref={challengeRef} isEdit={isEdit} selectedId={id} />
        </Paper>
      </Box>
    </MainContentContainer>
  );
};

export default ChallengeAddEditPage;
